// 盘点表状态
export default [{
  name: "美团配送",
  logistic: "mtps",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "美团跑腿(1)",
  logistic: "mtzb",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "美团跑腿(2)",
  logistic: "shuguopai",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "顺丰",
  logistic: "shunfeng",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "顺丰品质版",
  logistic: "shunfengu",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "货拉拉货运",
  logistic: "huolala",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "货拉拉跑腿直送",
  logistic: "huollpt",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "蜂鸟",
  logistic: "fengniao",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "蜂鸟众包",
  logistic: "ebaizb",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "蜂鸟PT",
  logistic: "fengpt",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "蜂鸟KA",
  logistic: "fengka",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "蜂鸟配送",
  logistic: "fengnew",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "蜂鸟直送",
  logistic: "fengzs",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "达达秒送",
  logistic: "dada",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "达达急送",
  logistic: "dadac",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "达达直送",
  logistic: "dadaz",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "曹操送",
  logistic: "caosong",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "爱跑腿",
  logistic: "ipaotui",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "中里办",
  logistic: "zlb",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "UU跑腿",
  logistic: "uupt",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "滴滴快送",
  logistic: "ddks",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "滴滴汽车送",
  logistic: "ddks:qc",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "裹小递",
  logistic: "guoxiaodi",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "裹小递(2)",
  logistic: "gxdpro",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "闪送",
  logistic: "bingex",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "快跑者",
  logistic: "keloop",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
},{
  name: "快服务",
  logistic: "fuwu",
  active: false,
  error: true,
  remarks: "价格计算中...",
  amount: "",
}]